// src/app/mock-data/laboratorio/parametros.mock.ts

import { ParametroLaboratorio } from '../../interfaces/laboratorio/parametro-laboratorio.interface';

// ==================== HEMATOLOGÍA (17 parámetros) ====================
export const MOCK_PARAMETROS_HEMATOLOGIA: ParametroLaboratorio[] = [
  // SERIE ERITROCITARIA (7 parámetros)
  {
    id: 1,
    nombre: 'Hemoglobina',
    categoria: 'hematologia',
    subcategoria: 'Serie Eritrocitaria',
    unidad: 'g/dL',
    tipo: 'numerico',
    rangoMinMujer: 12.1,
    rangoMaxMujer: 15.1,
    rangoMinHombre: 13.8,
    rangoMaxHombre: 17.2,
    rangoMin: 12.1,
    rangoMax: 17.2,
    aliases: ['Hemoglobina', 'Hb', 'HGB', 'Hemoglobin'],
    descripcion: 'Proteína de los glóbulos rojos que transporta oxígeno',
    activo: true,
  },
  {
    id: 2,
    nombre: 'Hematocrito',
    categoria: 'hematologia',
    subcategoria: 'Serie Eritrocitaria',
    unidad: '%',
    tipo: 'numerico',
    rangoMinMujer: 36.1,
    rangoMaxMujer: 44.3,
    rangoMinHombre: 40.7,
    rangoMaxHombre: 50.3,
    rangoMin: 36.1,
    rangoMax: 50.3,
    aliases: ['Hematocrito', 'Hto', 'HCT', 'Hematocrit'],
    descripcion: 'Porcentaje de glóbulos rojos en la sangre',
    activo: true,
  },
  {
    id: 3,
    nombre: 'Eritrocitos',
    categoria: 'hematologia',
    subcategoria: 'Serie Eritrocitaria',
    unidad: 'mill/μL',
    tipo: 'numerico',
    rangoMinMujer: 4.1,
    rangoMaxMujer: 5.7,
    rangoMinHombre: 5.0,
    rangoMaxHombre: 6.3,
    rangoMin: 4.1,
    rangoMax: 6.3,
    aliases: ['Eritrocitos', 'RBC', 'Glóbulos Rojos', 'Red Blood Cells'],
    descripcion: 'Conteo de glóbulos rojos',
    activo: true,
  },
  {
    id: 4,
    nombre: 'VCM',
    categoria: 'hematologia',
    subcategoria: 'Serie Eritrocitaria',
    unidad: 'fL',
    tipo: 'numerico',
    rangoMin: 80,
    rangoMax: 100,
    aliases: ['VCM', 'MCV', 'Volumen Corpuscular Medio'],
    descripcion: 'Tamaño promedio de los glóbulos rojos',
    activo: true,
  },
  {
    id: 5,
    nombre: 'HCM',
    categoria: 'hematologia',
    subcategoria: 'Serie Eritrocitaria',
    unidad: 'pg/cel',
    tipo: 'numerico',
    rangoMin: 27,
    rangoMax: 32,
    aliases: ['HCM', 'MCH', 'Hemoglobina Corpuscular Media'],
    descripcion: 'Cantidad de hemoglobina por glóbulo rojo',
    activo: true,
  },
  {
    id: 6,
    nombre: 'CHCM',
    categoria: 'hematologia',
    subcategoria: 'Serie Eritrocitaria',
    unidad: 'g/dL',
    tipo: 'numerico',
    rangoMin: 32,
    rangoMax: 36,
    aliases: ['CHCM', 'MCHC', 'Concentración de Hemoglobina Corpuscular Media'],
    descripcion: 'Concentración de hemoglobina en los glóbulos rojos',
    activo: true,
  },
  {
    id: 7,
    nombre: 'RDW',
    categoria: 'hematologia',
    subcategoria: 'Serie Eritrocitaria',
    unidad: '%',
    tipo: 'numerico',
    rangoMin: 11.5,
    rangoMax: 14.5,
    aliases: ['RDW', 'RDW-CV', 'Amplitud de Distribución Eritrocitaria'],
    descripcion: 'Variación en el tamaño de los glóbulos rojos',
    activo: true,
  },

  // SERIE LEUCOCITARIA (7 parámetros)
  {
    id: 8,
    nombre: 'Leucocitos',
    categoria: 'hematologia',
    subcategoria: 'Serie Leucocitaria',
    unidad: '/μL',
    tipo: 'numerico',
    rangoMin: 4500,
    rangoMax: 11000,
    aliases: ['Leucocitos', 'WBC', 'Glóbulos Blancos', 'White Blood Cells'],
    descripcion: 'Conteo total de glóbulos blancos',
    activo: true,
  },
  {
    id: 9,
    nombre: 'Neutrófilos',
    categoria: 'hematologia',
    subcategoria: 'Serie Leucocitaria',
    unidad: '%',
    tipo: 'numerico',
    rangoMin: 40,
    rangoMax: 70,
    aliases: ['Neutrófilos', 'Neutrofilos', 'Neutrophils', 'Segmentados'],
    descripcion: 'Tipo de glóbulo blanco que combate infecciones',
    activo: true,
  },
  {
    id: 10,
    nombre: 'Bandas',
    categoria: 'hematologia',
    subcategoria: 'Serie Leucocitaria',
    unidad: '%',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 5,
    aliases: ['Bandas', 'Neutrófilos en Banda', 'Band Neutrophils'],
    descripcion: 'Neutrófilos inmaduros',
    activo: true,
  },
  {
    id: 11,
    nombre: 'Linfocitos',
    categoria: 'hematologia',
    subcategoria: 'Serie Leucocitaria',
    unidad: '%',
    tipo: 'numerico',
    rangoMin: 20,
    rangoMax: 40,
    aliases: ['Linfocitos', 'Lymphocytes', 'Linf'],
    descripcion: 'Glóbulos blancos del sistema inmune',
    activo: true,
  },
  {
    id: 12,
    nombre: 'Monocitos',
    categoria: 'hematologia',
    subcategoria: 'Serie Leucocitaria',
    unidad: '%',
    tipo: 'numerico',
    rangoMin: 2,
    rangoMax: 8,
    aliases: ['Monocitos', 'Monocytes', 'Mono'],
    descripcion: 'Células que eliminan tejido dañado',
    activo: true,
  },
  {
    id: 13,
    nombre: 'Eosinófilos',
    categoria: 'hematologia',
    subcategoria: 'Serie Leucocitaria',
    unidad: '%',
    tipo: 'numerico',
    rangoMin: 1,
    rangoMax: 4,
    aliases: ['Eosinófilos', 'Eosinofilos', 'Eosinophils', 'Eos'],
    descripcion: 'Células que combaten parásitos y alergias',
    activo: true,
  },
  {
    id: 14,
    nombre: 'Basófilos',
    categoria: 'hematologia',
    subcategoria: 'Serie Leucocitaria',
    unidad: '%',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 1,
    aliases: ['Basófilos', 'Basofilos', 'Basophils', 'Baso'],
    descripcion: 'Células involucradas en respuestas alérgicas',
    activo: true,
  },

  // SERIE PLAQUETARIA (3 parámetros)
  {
    id: 15,
    nombre: 'Plaquetas',
    categoria: 'hematologia',
    subcategoria: 'Serie Plaquetaria',
    unidad: '/μL',
    tipo: 'numerico',
    rangoMin: 150000,
    rangoMax: 450000,
    aliases: ['Plaquetas', 'PLT', 'Platelets', 'Trombocitos'],
    descripcion: 'Células que ayudan a la coagulación',
    activo: true,
  },
  {
    id: 16,
    nombre: 'VPM',
    categoria: 'hematologia',
    subcategoria: 'Serie Plaquetaria',
    unidad: 'fL',
    tipo: 'numerico',
    rangoMin: 7.5,
    rangoMax: 11.5,
    aliases: ['VPM', 'MPV', 'Volumen Plaquetario Medio'],
    descripcion: 'Tamaño promedio de las plaquetas',
    activo: true,
  },
  {
    id: 17,
    nombre: 'PDW',
    categoria: 'hematologia',
    subcategoria: 'Serie Plaquetaria',
    unidad: '%',
    tipo: 'numerico',
    rangoMin: 10,
    rangoMax: 18,
    aliases: ['PDW', 'Amplitud de Distribución Plaquetaria'],
    descripcion: 'Variación en el tamaño de las plaquetas',
    activo: true,
  },
];

// ==================== QUÍMICA SANGUÍNEA (45 parámetros) ====================
export const MOCK_PARAMETROS_QUIMICA: ParametroLaboratorio[] = [
  // GLUCOSA (2 parámetros)
  {
    id: 20,
    nombre: 'Glucosa',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Metabolismo Glucosa',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 70,
    rangoMax: 100,
    aliases: ['Glucosa', 'Glucose', 'Glicemia', 'Glucosa en ayunas'],
    descripcion: 'Nivel de azúcar en sangre',
    activo: true,
  },
  {
    id: 21,
    nombre: 'HbA1c',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Metabolismo Glucosa',
    unidad: '%',
    tipo: 'numerico',
    rangoMin: 4.0,
    rangoMax: 5.7,
    aliases: ['HbA1c', 'Hemoglobina Glicosilada', 'A1C', 'Glycated Hemoglobin'],
    descripcion: 'Promedio de glucosa en los últimos 2-3 meses',
    activo: true,
  },

  // FUNCIÓN RENAL (4 parámetros)
  {
    id: 22,
    nombre: 'Creatinina',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Renal',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMinMujer: 0.6,
    rangoMaxMujer: 1.2,
    rangoMinHombre: 0.7,
    rangoMaxHombre: 1.3,
    rangoMin: 0.6,
    rangoMax: 1.3,
    aliases: ['Creatinina', 'Creatinine', 'Creat'],
    descripcion: 'Producto de desecho filtrado por los riñones',
    activo: true,
  },
  {
    id: 23,
    nombre: 'Urea',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Renal',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 10,
    rangoMax: 50,
    aliases: ['Urea', 'BUN', 'Nitrógeno Ureico', 'Blood Urea Nitrogen'],
    descripcion: 'Producto del metabolismo de proteínas',
    activo: true,
  },
  {
    id: 24,
    nombre: 'Ácido Úrico',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Renal',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMinMujer: 2.5,
    rangoMaxMujer: 6.0,
    rangoMinHombre: 3.5,
    rangoMaxHombre: 7.2,
    rangoMin: 2.5,
    rangoMax: 7.2,
    aliases: ['Ácido Úrico', 'Acido Urico', 'Uric Acid', 'AU'],
    descripcion: 'Producto del metabolismo de purinas',
    activo: true,
  },
  {
    id: 25,
    nombre: 'TFG',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Renal',
    unidad: 'mL/min',
    tipo: 'numerico',
    rangoMin: 90,
    rangoMax: 120,
    aliases: ['TFG', 'Tasa de Filtración Glomerular', 'GFR', 'eGFR'],
    descripcion: 'Indicador de función renal',
    activo: true,
  },

  // PERFIL LÍPIDOS (6 parámetros)
  {
    id: 26,
    nombre: 'Colesterol Total',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Perfil Lípidos',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 200,
    aliases: ['Colesterol Total', 'Colesterol', 'Total Cholesterol', 'CHOL'],
    descripcion: 'Nivel total de colesterol en sangre',
    activo: true,
  },
  {
    id: 27,
    nombre: 'HDL',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Perfil Lípidos',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMinHombre: 40,
    rangoMaxHombre: 200,
    rangoMinMujer: 50,
    rangoMaxMujer: 200,
    rangoMin: 40,
    rangoMax: 200,
    aliases: ['HDL', 'Colesterol HDL', 'HDL Cholesterol', 'Colesterol Bueno'],
    descripcion: 'Colesterol de alta densidad (bueno)',
    activo: true,
  },
  {
    id: 28,
    nombre: 'LDL',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Perfil Lípidos',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 100,
    aliases: ['LDL', 'Colesterol LDL', 'LDL Cholesterol', 'Colesterol Malo'],
    descripcion: 'Colesterol de baja densidad (malo)',
    activo: true,
  },
  {
    id: 29,
    nombre: 'VLDL',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Perfil Lípidos',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 30,
    aliases: ['VLDL', 'Colesterol VLDL', 'Very Low Density Lipoprotein'],
    descripcion: 'Colesterol de muy baja densidad',
    activo: true,
  },
  {
    id: 30,
    nombre: 'Triglicéridos',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Perfil Lípidos',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 150,
    aliases: ['Triglicéridos', 'Trigliceridos', 'Triglycerides', 'TG'],
    descripcion: 'Tipo de grasa en la sangre',
    activo: true,
  },
  {
    id: 31,
    nombre: 'Índice Aterogénico',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Perfil Lípidos',
    unidad: 'ratio',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 4.5,
    aliases: ['Índice Aterogénico', 'Indice Aterogenico', 'Atherogenic Index'],
    descripcion: 'Ratio colesterol total/HDL',
    activo: true,
  },

  // FUNCIÓN HEPÁTICA (13 parámetros)
  {
    id: 32,
    nombre: 'Bilirrubina Total',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 0.1,
    rangoMax: 1.2,
    aliases: ['Bilirrubina Total', 'Total Bilirubin', 'TBIL'],
    descripcion: 'Producto de degradación de hemoglobina',
    activo: true,
  },
  {
    id: 33,
    nombre: 'Bilirrubina Directa',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 0.3,
    aliases: ['Bilirrubina Directa', 'Direct Bilirubin', 'DBIL', 'Bilirrubina Conjugada'],
    descripcion: 'Bilirrubina procesada por el hígado',
    activo: true,
  },
  {
    id: 34,
    nombre: 'Bilirrubina Indirecta',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 0.9,
    aliases: ['Bilirrubina Indirecta', 'Indirect Bilirubin', 'IBIL', 'Bilirrubina No Conjugada'],
    descripcion: 'Bilirrubina antes de ser procesada',
    activo: true,
  },
  {
    id: 35,
    nombre: 'TGO/AST',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'U/L',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 40,
    aliases: ['TGO', 'AST', 'TGO/AST', 'Transaminasa Glutámico Oxalacética', 'SGOT'],
    descripcion: 'Enzima hepática',
    activo: true,
  },
  {
    id: 36,
    nombre: 'TGP/ALT',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'U/L',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 41,
    aliases: ['TGP', 'ALT', 'TGP/ALT', 'Transaminasa Glutámico Pirúvica', 'SGPT'],
    descripcion: 'Enzima hepática',
    activo: true,
  },
  {
    id: 37,
    nombre: 'Fosfatasa Alcalina',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'U/L',
    tipo: 'numerico',
    rangoMin: 30,
    rangoMax: 120,
    aliases: ['Fosfatasa Alcalina', 'ALP', 'Alkaline Phosphatase', 'FA'],
    descripcion: 'Enzima relacionada con hígado y huesos',
    activo: true,
  },
  {
    id: 38,
    nombre: 'GGT',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'U/L',
    tipo: 'numerico',
    rangoMinHombre: 0,
    rangoMaxHombre: 55,
    rangoMinMujer: 0,
    rangoMaxMujer: 38,
    rangoMin: 0,
    rangoMax: 55,
    aliases: ['GGT', 'Gamma-GT', 'Gamma Glutamil Transferasa'],
    descripcion: 'Enzima hepática sensible a alcohol',
    activo: true,
  },
  {
    id: 39,
    nombre: 'Proteínas Totales',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'g/dL',
    tipo: 'numerico',
    rangoMin: 6.0,
    rangoMax: 8.3,
    aliases: ['Proteínas Totales', 'Proteinas Totales', 'Total Protein', 'TP'],
    descripcion: 'Suma de albúmina y globulinas',
    activo: true,
  },
  {
    id: 40,
    nombre: 'Albúmina',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'g/dL',
    tipo: 'numerico',
    rangoMin: 3.5,
    rangoMax: 5.2,
    aliases: ['Albúmina', 'Albumina', 'Albumin', 'ALB'],
    descripcion: 'Proteína principal del plasma',
    activo: true,
  },
  {
    id: 41,
    nombre: 'Globulinas',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'g/dL',
    tipo: 'numerico',
    rangoMin: 2.0,
    rangoMax: 3.5,
    aliases: ['Globulinas', 'Globulins'],
    descripcion: 'Grupo de proteínas incluyendo anticuerpos',
    activo: true,
  },
  {
    id: 42,
    nombre: 'Relación A/G',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'ratio',
    tipo: 'numerico',
    rangoMin: 1.0,
    rangoMax: 2.5,
    aliases: ['Relación A/G', 'A/G Ratio', 'Albumina/Globulina'],
    descripcion: 'Proporción albúmina/globulinas',
    activo: true,
  },
  {
    id: 43,
    nombre: 'LDH',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'U/L',
    tipo: 'numerico',
    rangoMin: 140,
    rangoMax: 280,
    aliases: ['LDH', 'Lactato Deshidrogenasa', 'Lactate Dehydrogenase'],
    descripcion: 'Enzima de daño celular',
    activo: true,
  },
  {
    id: 44,
    nombre: 'Amilasa',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Función Hepática',
    unidad: 'U/L',
    tipo: 'numerico',
    rangoMin: 30,
    rangoMax: 110,
    aliases: ['Amilasa', 'Amylase', 'AMY'],
    descripcion: 'Enzima digestiva',
    activo: true,
  },

  // ELECTROLITOS (6 parámetros)
  {
    id: 45,
    nombre: 'Sodio',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Electrolitos',
    unidad: 'mEq/L',
    tipo: 'numerico',
    rangoMin: 135,
    rangoMax: 145,
    aliases: ['Sodio', 'Sodium', 'Na', 'Na+'],
    descripcion: 'Electrolito principal del líquido extracelular',
    activo: true,
  },
  {
    id: 46,
    nombre: 'Potasio',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Electrolitos',
    unidad: 'mEq/L',
    tipo: 'numerico',
    rangoMin: 3.5,
    rangoMax: 5.0,
    aliases: ['Potasio', 'Potassium', 'K', 'K+'],
    descripcion: 'Electrolito esencial para función muscular',
    activo: true,
  },
  {
    id: 47,
    nombre: 'Cloro',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Electrolitos',
    unidad: 'mEq/L',
    tipo: 'numerico',
    rangoMin: 96,
    rangoMax: 106,
    aliases: ['Cloro', 'Chloride', 'Cl', 'Cl-'],
    descripcion: 'Electrolito que mantiene balance ácido-base',
    activo: true,
  },
  {
    id: 48,
    nombre: 'Calcio',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Electrolitos',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 8.5,
    rangoMax: 10.5,
    aliases: ['Calcio', 'Calcium', 'Ca', 'Ca++'],
    descripcion: 'Mineral esencial para huesos y músculos',
    activo: true,
  },
  {
    id: 49,
    nombre: 'Fósforo',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Electrolitos',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 2.5,
    rangoMax: 4.5,
    aliases: ['Fósforo', 'Fosforo', 'Phosphorus', 'P'],
    descripcion: 'Mineral importante para huesos y energía',
    activo: true,
  },
  {
    id: 50,
    nombre: 'Magnesio',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Electrolitos',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 1.7,
    rangoMax: 2.2,
    aliases: ['Magnesio', 'Magnesium', 'Mg', 'Mg++'],
    descripcion: 'Mineral esencial para funciones enzimáticas',
    activo: true,
  },

  // METABOLISMO HIERRO (4 parámetros)
  {
    id: 51,
    nombre: 'Hierro Sérico',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Metabolismo Hierro',
    unidad: 'μg/dL',
    tipo: 'numerico',
    rangoMinMujer: 50,
    rangoMaxMujer: 170,
    rangoMinHombre: 65,
    rangoMaxHombre: 175,
    rangoMin: 50,
    rangoMax: 175,
    aliases: ['Hierro Sérico', 'Hierro Serico', 'Serum Iron', 'Fe'],
    descripcion: 'Hierro circulante en sangre',
    activo: true,
  },
  {
    id: 52,
    nombre: 'Ferritina',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Metabolismo Hierro',
    unidad: 'ng/mL',
    tipo: 'numerico',
    rangoMinMujer: 11,
    rangoMaxMujer: 307,
    rangoMinHombre: 24,
    rangoMaxHombre: 336,
    rangoMin: 11,
    rangoMax: 336,
    aliases: ['Ferritina', 'Ferritin'],
    descripcion: 'Proteína que almacena hierro',
    activo: true,
  },
  {
    id: 53,
    nombre: 'Transferrina',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Metabolismo Hierro',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 200,
    rangoMax: 360,
    aliases: ['Transferrina', 'Transferrin', 'TRF'],
    descripcion: 'Proteína que transporta hierro',
    activo: true,
  },
  {
    id: 54,
    nombre: 'TIBC',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Metabolismo Hierro',
    unidad: 'μg/dL',
    tipo: 'numerico',
    rangoMin: 250,
    rangoMax: 400,
    aliases: ['TIBC', 'Capacidad Total de Fijación de Hierro', 'Total Iron Binding Capacity'],
    descripcion: 'Capacidad de la sangre para transportar hierro',
    activo: true,
  },

  // OTROS (10 parámetros)
  {
    id: 55,
    nombre: 'PCR',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Marcadores Inflamatorios',
    unidad: 'mg/L',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 3.0,
    aliases: ['PCR', 'Proteína C Reactiva', 'CRP', 'C-Reactive Protein'],
    descripcion: 'Marcador de inflamación',
    activo: true,
  },
  {
    id: 56,
    nombre: 'VSG',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Marcadores Inflamatorios',
    unidad: 'mm/h',
    tipo: 'numerico',
    rangoMinMujer: 0,
    rangoMaxMujer: 20,
    rangoMinHombre: 0,
    rangoMaxHombre: 15,
    rangoMin: 0,
    rangoMax: 20,
    aliases: ['VSG', 'Velocidad de Sedimentación Globular', 'ESR', 'Eritrosedimentación'],
    descripcion: 'Marcador de inflamación',
    activo: true,
  },
  {
    id: 57,
    nombre: 'Vitamina D',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Vitaminas',
    unidad: 'ng/mL',
    tipo: 'numerico',
    rangoMin: 30,
    rangoMax: 100,
    aliases: ['Vitamina D', '25-OH Vitamina D', 'Vitamin D'],
    descripcion: 'Vitamina esencial para huesos',
    activo: true,
  },
  {
    id: 58,
    nombre: 'Vitamina B12',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Vitaminas',
    unidad: 'pg/mL',
    tipo: 'numerico',
    rangoMin: 200,
    rangoMax: 900,
    aliases: ['Vitamina B12', 'Cobalamina', 'B12'],
    descripcion: 'Vitamina esencial para sistema nervioso',
    activo: true,
  },
  {
    id: 59,
    nombre: 'Ácido Fólico',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Vitaminas',
    unidad: 'ng/mL',
    tipo: 'numerico',
    rangoMin: 2.7,
    rangoMax: 17.0,
    aliases: ['Ácido Fólico', 'Acido Folico', 'Folato', 'Folic Acid'],
    descripcion: 'Vitamina esencial para formación de células',
    activo: true,
  },
  {
    id: 60,
    nombre: 'TSH',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Hormonas Tiroideas',
    unidad: 'μUI/mL',
    tipo: 'numerico',
    rangoMin: 0.4,
    rangoMax: 4.0,
    aliases: ['TSH', 'Hormona Estimulante de Tiroides', 'Thyroid Stimulating Hormone'],
    descripcion: 'Hormona que regula la tiroides',
    activo: true,
  },
  {
    id: 61,
    nombre: 'T3 Total',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Hormonas Tiroideas',
    unidad: 'ng/dL',
    tipo: 'numerico',
    rangoMin: 80,
    rangoMax: 200,
    aliases: ['T3', 'T3 Total', 'Triiodotironina'],
    descripcion: 'Hormona tiroidea activa',
    activo: true,
  },
  {
    id: 62,
    nombre: 'T4 Libre',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Hormonas Tiroideas',
    unidad: 'ng/dL',
    tipo: 'numerico',
    rangoMin: 0.8,
    rangoMax: 1.8,
    aliases: ['T4 Libre', 'Free T4', 'Tiroxina Libre'],
    descripcion: 'Hormona tiroidea no unida a proteínas',
    activo: true,
  },
  {
    id: 63,
    nombre: 'Cortisol',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Hormonas',
    unidad: 'μg/dL',
    tipo: 'numerico',
    rangoMin: 5,
    rangoMax: 25,
    aliases: ['Cortisol', 'Hidrocortisona'],
    descripcion: 'Hormona del estrés',
    activo: true,
  },
  {
    id: 64,
    nombre: 'Testosterona Total',
    categoria: 'quimica_sanguinea',
    subcategoria: 'Hormonas',
    unidad: 'ng/dL',
    tipo: 'numerico',
    rangoMinHombre: 300,
    rangoMaxHombre: 1000,
    rangoMinMujer: 15,
    rangoMaxMujer: 70,
    rangoMin: 15,
    rangoMax: 1000,
    aliases: ['Testosterona', 'Testosterona Total', 'Testosterone'],
    descripcion: 'Hormona sexual masculina',
    activo: true,
  },
];

// ==================== COAGULACIÓN (5 parámetros) ====================
export const MOCK_PARAMETROS_COAGULACION: ParametroLaboratorio[] = [
  {
    id: 70,
    nombre: 'Tiempo de Protrombina',
    categoria: 'coagulacion',
    subcategoria: 'Coagulación',
    unidad: 'seg',
    tipo: 'numerico',
    rangoMin: 11,
    rangoMax: 13.5,
    aliases: ['Tiempo de Protrombina', 'TP', 'PT', 'Prothrombin Time'],
    descripcion: 'Tiempo de coagulación de la sangre',
    activo: true,
  },
  {
    id: 71,
    nombre: 'INR',
    categoria: 'coagulacion',
    subcategoria: 'Coagulación',
    unidad: 'ratio',
    tipo: 'numerico',
    rangoMin: 0.8,
    rangoMax: 1.2,
    aliases: ['INR', 'International Normalized Ratio', 'Razón Normalizada Internacional'],
    descripcion: 'Estandarización del tiempo de protrombina',
    activo: true,
  },
  {
    id: 72,
    nombre: 'TTP',
    categoria: 'coagulacion',
    subcategoria: 'Coagulación',
    unidad: 'seg',
    tipo: 'numerico',
    rangoMin: 25,
    rangoMax: 35,
    aliases: ['TTP', 'TTPA', 'Tiempo de Tromboplastina Parcial', 'aPTT'],
    descripcion: 'Tiempo de coagulación parcial',
    activo: true,
  },
  {
    id: 73,
    nombre: 'Fibrinógeno',
    categoria: 'coagulacion',
    subcategoria: 'Coagulación',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 200,
    rangoMax: 400,
    aliases: ['Fibrinógeno', 'Fibrinogen', 'Factor I'],
    descripcion: 'Proteína de coagulación',
    activo: true,
  },
  {
    id: 74,
    nombre: 'Tiempo de Sangrado',
    categoria: 'coagulacion',
    subcategoria: 'Coagulación',
    unidad: 'min',
    tipo: 'numerico',
    rangoMin: 2,
    rangoMax: 7,
    aliases: ['Tiempo de Sangrado', 'Bleeding Time', 'BT'],
    descripcion: 'Tiempo que tarda en detenerse el sangrado',
    activo: true,
  },
];

// ==================== ORINA (30 parámetros) ====================
export const MOCK_PARAMETROS_ORINA: ParametroLaboratorio[] = [
  // PROPIEDADES FÍSICAS (4 parámetros)
  {
    id: 80,
    nombre: 'Color',
    categoria: 'orina',
    subcategoria: 'Propiedades Físicas',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Amarillo', 'Amarillo claro', 'Amarillo paja'],
    valoresAnormales: ['Rojo', 'Marrón', 'Verde', 'Turbio'],
    aliases: ['Color', 'Color Orina'],
    descripcion: 'Color de la orina',
    activo: true,
  },
  {
    id: 81,
    nombre: 'Aspecto',
    categoria: 'orina',
    subcategoria: 'Propiedades Físicas',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Claro', 'Transparente'],
    valoresAnormales: ['Turbio', 'Lechoso', 'Opaco'],
    aliases: ['Aspecto', 'Apariencia'],
    descripcion: 'Transparencia de la orina',
    activo: true,
  },
  {
    id: 82,
    nombre: 'Densidad',
    categoria: 'orina',
    subcategoria: 'Propiedades Físicas',
    unidad: '',
    tipo: 'numerico',
    rangoMin: 1.005,
    rangoMax: 1.03,
    aliases: ['Densidad', 'Gravedad Específica', 'Specific Gravity'],
    descripcion: 'Concentración de partículas en orina',
    activo: true,
  },
  {
    id: 83,
    nombre: 'Volumen',
    categoria: 'orina',
    subcategoria: 'Propiedades Físicas',
    unidad: 'mL/24h',
    tipo: 'numerico',
    rangoMin: 800,
    rangoMax: 2000,
    aliases: ['Volumen', 'Volumen 24h', 'Volume'],
    descripcion: 'Volumen total de orina en 24 horas',
    activo: true,
  },

  // PROPIEDADES QUÍMICAS (9 parámetros)
  {
    id: 84,
    nombre: 'pH',
    categoria: 'orina',
    subcategoria: 'Propiedades Químicas',
    unidad: '',
    tipo: 'numerico',
    rangoMin: 4.6,
    rangoMax: 8.0,
    aliases: ['pH', 'pH Urinario'],
    descripcion: 'Acidez o alcalinidad de la orina',
    activo: true,
  },
  {
    id: 85,
    nombre: 'Glucosa Urinaria',
    categoria: 'orina',
    subcategoria: 'Propiedades Químicas',
    unidad: 'mg/dL',
    tipo: 'cualitativo',
    valoresNormales: ['Negativo'],
    valoresAnormales: ['Positivo', '+', '++', '+++', '++++'],
    aliases: ['Glucosa', 'Glucose Urine'],
    descripcion: 'Presencia de glucosa en orina',
    activo: true,
  },
  {
    id: 86,
    nombre: 'Proteínas Urinarias',
    categoria: 'orina',
    subcategoria: 'Propiedades Químicas',
    unidad: 'mg/dL',
    tipo: 'cualitativo',
    valoresNormales: ['Negativo', 'Trazas'],
    valoresAnormales: ['Positivo', '+', '++', '+++', '++++'],
    aliases: ['Proteínas', 'Proteinas', 'Protein Urine'],
    descripcion: 'Presencia de proteínas en orina',
    activo: true,
  },
  {
    id: 87,
    nombre: 'Cetonas',
    categoria: 'orina',
    subcategoria: 'Propiedades Químicas',
    unidad: 'mg/dL',
    tipo: 'cualitativo',
    valoresNormales: ['Negativo'],
    valoresAnormales: ['Positivo', '+', '++', '+++'],
    aliases: ['Cetonas', 'Ketones', 'Cuerpos Cetónicos'],
    descripcion: 'Presencia de cetonas en orina',
    activo: true,
  },
  {
    id: 88,
    nombre: 'Sangre Urinaria',
    categoria: 'orina',
    subcategoria: 'Propiedades Químicas',
    unidad: '',
    tipo: 'cualitativo',
    valoresNormales: ['Negativo'],
    valoresAnormales: ['Positivo', '+', '++', '+++'],
    aliases: ['Sangre', 'Blood', 'Hemoglobina'],
    descripcion: 'Presencia de sangre en orina',
    activo: true,
  },
  {
    id: 89,
    nombre: 'Bilirrubina Urinaria',
    categoria: 'orina',
    subcategoria: 'Propiedades Químicas',
    unidad: '',
    tipo: 'cualitativo',
    valoresNormales: ['Negativo'],
    valoresAnormales: ['Positivo', '+', '++'],
    aliases: ['Bilirrubina', 'Bilirubin'],
    descripcion: 'Presencia de bilirrubina en orina',
    activo: true,
  },
  {
    id: 90,
    nombre: 'Urobilinógeno',
    categoria: 'orina',
    subcategoria: 'Propiedades Químicas',
    unidad: 'mg/dL',
    tipo: 'numerico',
    rangoMin: 0.1,
    rangoMax: 1.0,
    aliases: ['Urobilinógeno', 'Urobilinogeno', 'Urobilinogen'],
    descripcion: 'Producto de degradación de bilirrubina',
    activo: true,
  },
  {
    id: 91,
    nombre: 'Nitritos',
    categoria: 'orina',
    subcategoria: 'Propiedades Químicas',
    unidad: '',
    tipo: 'cualitativo',
    valoresNormales: ['Negativo'],
    valoresAnormales: ['Positivo'],
    aliases: ['Nitritos', 'Nitrites'],
    descripcion: 'Indicador de infección bacteriana',
    activo: true,
  },
  {
    id: 92,
    nombre: 'Esterasa Leucocitaria',
    categoria: 'orina',
    subcategoria: 'Propiedades Químicas',
    unidad: '',
    tipo: 'cualitativo',
    valoresNormales: ['Negativo'],
    valoresAnormales: ['Positivo', '+', '++', '+++'],
    aliases: ['Esterasa Leucocitaria', 'Leukocyte Esterase', 'LE'],
    descripcion: 'Indicador de leucocitos en orina',
    activo: true,
  },

  // SEDIMENTO MICROSCÓPICO (17 parámetros)
  {
    id: 93,
    nombre: 'Leucocitos Orina',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '/campo',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 5,
    aliases: ['Leucocitos', 'WBC Urine', 'Glóbulos Blancos Orina'],
    descripcion: 'Conteo de leucocitos por campo',
    activo: true,
  },
  {
    id: 94,
    nombre: 'Eritrocitos Orina',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '/campo',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 4,
    aliases: ['Eritrocitos', 'RBC Urine', 'Hematíes', 'Glóbulos Rojos Orina'],
    descripcion: 'Conteo de eritrocitos por campo',
    activo: true,
  },
  {
    id: 95,
    nombre: 'Células Epiteliales',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Escasas', 'Algunas', 'Pocas'],
    valoresAnormales: ['Abundantes', 'Numerosas'],
    aliases: ['Células Epiteliales', 'Epithelial Cells'],
    descripcion: 'Células descamadas del tracto urinario',
    activo: true,
  },
  {
    id: 96,
    nombre: 'Cilindros Hialinos',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '/campo',
    tipo: 'numerico',
    rangoMin: 0,
    rangoMax: 2,
    aliases: ['Cilindros Hialinos', 'Hyaline Casts'],
    descripcion: 'Cilindros proteicos normales',
    activo: true,
  },
  {
    id: 97,
    nombre: 'Cilindros Granulosos',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '/campo',
    tipo: 'texto',
    valoresNormales: ['Ausentes'],
    valoresAnormales: ['Presentes', 'Escasos', 'Abundantes'],
    aliases: ['Cilindros Granulosos', 'Granular Casts'],
    descripcion: 'Indicador de daño renal',
    activo: true,
  },
  {
    id: 98,
    nombre: 'Cilindros Leucocitarios',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes'],
    valoresAnormales: ['Presentes'],
    aliases: ['Cilindros Leucocitarios', 'WBC Casts'],
    descripcion: 'Indicador de infección renal',
    activo: true,
  },
  {
    id: 99,
    nombre: 'Cilindros Eritrocitarios',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes'],
    valoresAnormales: ['Presentes'],
    aliases: ['Cilindros Eritrocitarios', 'RBC Casts'],
    descripcion: 'Indicador de enfermedad glomerular',
    activo: true,
  },
  {
    id: 100,
    nombre: 'Cilindros Céreos',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes'],
    valoresAnormales: ['Presentes'],
    aliases: ['Cilindros Céreos', 'Waxy Casts'],
    descripcion: 'Indicador de enfermedad renal crónica',
    activo: true,
  },
  {
    id: 101,
    nombre: 'Cristales Ácido Úrico',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes', 'Escasos'],
    valoresAnormales: ['Abundantes'],
    aliases: ['Cristales Ácido Úrico', 'Uric Acid Crystals'],
    descripcion: 'Cristales en orina ácida',
    activo: true,
  },
  {
    id: 102,
    nombre: 'Cristales Oxalato de Calcio',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes', 'Escasos'],
    valoresAnormales: ['Abundantes'],
    aliases: ['Cristales Oxalato', 'Calcium Oxalate Crystals'],
    descripcion: 'Cristales comunes en orina',
    activo: true,
  },
  {
    id: 103,
    nombre: 'Cristales Fosfatos',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes', 'Escasos'],
    valoresAnormales: ['Abundantes'],
    aliases: ['Cristales Fosfatos', 'Phosphate Crystals'],
    descripcion: 'Cristales en orina alcalina',
    activo: true,
  },
  {
    id: 104,
    nombre: 'Bacterias',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes', 'Escasas'],
    valoresAnormales: ['Abundantes', 'Numerosas'],
    aliases: ['Bacterias', 'Bacteria'],
    descripcion: 'Presencia de bacterias en orina',
    activo: true,
  },
  {
    id: 105,
    nombre: 'Levaduras',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes'],
    valoresAnormales: ['Presentes'],
    aliases: ['Levaduras', 'Yeast', 'Hongos'],
    descripcion: 'Indicador de infección por hongos',
    activo: true,
  },
  {
    id: 106,
    nombre: 'Parásitos',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes'],
    valoresAnormales: ['Presentes'],
    aliases: ['Parásitos', 'Parasites'],
    descripcion: 'Presencia de parásitos',
    activo: true,
  },
  {
    id: 107,
    nombre: 'Moco',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Escaso', 'Moderado'],
    valoresAnormales: ['Abundante'],
    aliases: ['Moco', 'Mucus'],
    descripcion: 'Secreción de mucosa urinaria',
    activo: true,
  },
  {
    id: 108,
    nombre: 'Espermatozoides',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Ausentes', 'Presentes'],
    aliases: ['Espermatozoides', 'Sperm'],
    descripcion: 'Presencia de espermatozoides (normal en hombres)',
    activo: true,
  },
  {
    id: 109,
    nombre: 'Filamento Mucoso',
    categoria: 'orina',
    subcategoria: 'Sedimento Microscópico',
    unidad: '',
    tipo: 'texto',
    valoresNormales: ['Escaso'],
    valoresAnormales: ['Abundante'],
    aliases: ['Filamento Mucoso', 'Mucus Threads'],
    descripcion: 'Hebras de moco en orina',
    activo: true,
  },
];

// ==================== EXPORTAR TODOS ====================
export const MOCK_PARAMETROS_TODOS: ParametroLaboratorio[] = [
  ...MOCK_PARAMETROS_HEMATOLOGIA,
  ...MOCK_PARAMETROS_QUIMICA,
  ...MOCK_PARAMETROS_COAGULACION,
  ...MOCK_PARAMETROS_ORINA,
];

// Función helper para inicializar localStorage
export function inicializarParametrosEnLocalStorage(): void {
  const existente = localStorage.getItem('parametros_laboratorio');

  if (!existente) {
    localStorage.setItem('parametros_laboratorio', JSON.stringify(MOCK_PARAMETROS_TODOS));
    console.log('✅ Catálogo de parámetros inicializado en localStorage');
    console.log(`📊 Total parámetros: ${MOCK_PARAMETROS_TODOS.length}`);
  } else {
    console.log('ℹ️ Catálogo ya existe en localStorage');
  }
}
